import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { resultsConfigSelector } from 'ctm-selectors';
import { connect } from 'react-redux';

import { getBreakpointFromManor } from 'ctm-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { currencySymbol } from '../../products/common/number_formatter';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginTop: '2.4rem',
        marginBottom: '8.3rem'
    },
    title: {
        marginBottom: '2.4rem'
    },
    bold: {
        fontWeight: theme.fontWeight.semibold
    },
    text: {
        extend: ({ breakpoint }) => {
            if (breakpoint === 'sm' || breakpoint === 'md') {
                return {
                    fontSize: theme.fontSize.lg
                };
            }
            if (breakpoint === 'lg') {
                return {
                    fontSize: theme.fontSize.xl
                };
            }
            return {
                fontSize: theme.fontSize.base
            };
        }
    }

}));

const _HigherExcessNotice = ({ selectedExcessValue }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    return (
        <div className={classNames('test-emptyState-higherExcessNotice', classes.container)}>
            <Typography align="center" className={classNames(classes.title, classes.text)}>
                {`We didn't receive any quotes from our providers for policies that have an excess of ${currencySymbol}${selectedExcessValue || ''} and below.`}
            </Typography>
            <Typography component={'span'} align="center" className={classNames(classes.text)}>
                {'Use the '}
                <Typography display={'inline'} className={classNames(classes.bold, classes.text)}>{" 'Return to all products' "}</Typography>
                {'button above to review all results.'}
            </Typography>
        </div>
    );
};

_HigherExcessNotice.propTypes = {
    selectedExcessValue: PropTypes.string
};

const mapStateToProps = (state) => {
    const selectedExcessValue = resultsConfigSelector(state).getIn('filters.requestedExcess'.split('.'));
    return {
        selectedExcessValue
    };
};

const HigherExcessNotice = connect(mapStateToProps)(_HigherExcessNotice);

export { HigherExcessNotice, _HigherExcessNotice };
